import React, { useCallback } from 'react'
import { IDocumentDefault, TSchemaDocument } from '../../../../../api/types'
import { ErrorBoundary } from '@reapitform/utils'
import { DocumentForm } from '../form-document'
import { useDefaultsDocumentPost } from '../../../../../api/defaults/documents/post'
import { Button, ButtonGroup } from '@reapit/elements'
import { Drawer } from '@reapitform/common-ui'

interface IAddDocumentProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  refreshList: (data: IDocumentDefault[] | ((preData: IDocumentDefault[]) => IDocumentDefault[])) => void
}

export const AddDocument: React.FC<IAddDocumentProps> = ({ isOpen, onOpenChange, refreshList }) => {
  const { isLoading: isSubmitting, addDocument } = useDefaultsDocumentPost()

  const formId: string = React.useMemo(() => 'form-add-document', [])

  const handleClose = () => onOpenChange(false)
  const handleConfirm = async (data: TSchemaDocument) => {
    const result = await addDocument({
      defaultAttachmentFileID: data.document.fileId,
      defaultAttachmentFileSize: data.document.fileSize,
      documentName: data.document.fileName,
      formType: data.formType,
    })

    refreshList((prevData) => [...prevData, result])
    handleClose()
  }

  const DrawerFooter = useCallback(() => {
    return (
      <ButtonGroup alignment="right">
        <Button intent="default" disabled={isSubmitting} onClick={handleClose}>
          Cancel
        </Button>
        <Button loading={isSubmitting} disabled={isSubmitting} intent="primary" type="submit" form={formId}>
          Add Document
        </Button>
      </ButtonGroup>
    )
  }, [isSubmitting, handleClose])

  return (
    <ErrorBoundary>
      <Drawer
        {...{ onDrawerClose: handleClose, isOpen, title: 'Upload Document' }}
        footerItems={<DrawerFooter />}
        canDismiss
      >
        <DocumentForm formId={formId} onSubmit={handleConfirm} />
      </Drawer>
    </ErrorBoundary>
  )
}
